export default __webpack_public_path__ + "static/ChatIcon-872026565534a3ea50cec31f71689f6e.webp";